/**
 * Get a promise that never resolves
 * @returns {Promise}
 */
export default function forever() {
    return new Promise(() => {});
}
